import { ButtonGroup, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { FC } from "react";
import { Form, Formik } from 'formik';
import { object, string } from "yup";
import { ButtonSubmit, FormTextArea, Modal } from "components";
import { usePack, useRunSync, useToastNotification } from "lib/hooks";
import { updateAsset } from "../../../api";
import { Asset } from "lib/types";

const validationSchema = object({
  value: string(),
});


export const EditHtmlModal:FC<{ asset: Asset<any>, onClose: any, isOpen: boolean }> = ({ asset, onClose, isOpen }) => {
  const { sync } = useRunSync(asset?.pack_id);
  const { errorToast, successToast } = useToastNotification();
  const { data: pack } = usePack(asset?.pack_id);

  if (!asset) {
    return null;
  }

  const onSubmit = async (values: { value: string }): Promise<void> => {
    if ( values.value === asset.data.value) {
      return onClose();
    }

    try {
      await updateAsset({ ...asset, data: { ...asset.data, ...values }}, pack.key);
      await sync();
      successToast({ title: 'Success', description: "The asset has been updated." });
    } catch (e) {
      errorToast({ title: 'Error', description: "Could not update, please try again." });
    }

    onClose();
  }

  return (
    <Modal
      title={"Edit HTML"}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Formik initialValues={{ value: asset.data.value }} validationSchema={validationSchema} onSubmit={onSubmit}>
        <Form>
          <ModalBody>
            <FormTextArea name="value" label="HTML" />
          </ModalBody>
          <ModalFooter>
            <ButtonGroup width="100%" justifyContent="end">
              <Button variant="cancel" onClick={onClose}>Cancel</Button>
              <ButtonSubmit>Save</ButtonSubmit>
            </ButtonGroup>
          </ModalFooter>
        </Form>
      </Formik>
    </Modal>
  )
};
